import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';
import { ILocation } from '../../store/pik_data/location';

export enum ELocationsActionTypes {
  InitLocations = 'LOCATIONS/INIT',
}

export type TInitLocations = ITypedReduxAction<ELocationsActionTypes.InitLocations, ILocation[]>;

export const initLocations: (locations: ILocation[]) => TInitLocations = actionGenerator<
  ELocationsActionTypes.InitLocations,
  ILocation[]
>(ELocationsActionTypes.InitLocations);
